import { AppInstanceShort, MayBeNull } from '@wpp-open/core'

import { sortBy } from 'utils/common'

export interface Group {
  id: string
  name: string
  description: MayBeNull<string>
  order: MayBeNull<number>
}

export type GroupOrder = Omit<Group, 'name' | 'description'>

export interface SubGroupItem {
  subgroup: Group
  appInstances: AppInstanceShort[]
}

export interface GroupedItem {
  group: Group
  subgroups: SubGroupItem[]
  appInstances: AppInstanceShort[]
}

export const getOrderedEntities = <T extends GroupedItem | SubGroupItem>(
  key: keyof T,
  items: T[],
  orderedItems: GroupOrder[],
) => {
  return sortBy(
    items.map(item => {
      const currentItem = item[key] as Group
      currentItem.order = orderedItems.find(({ id }) => id === currentItem.id)!.order
      return item
    }, []),
    item => (item[key] as Group).order || Number.POSITIVE_INFINITY,
  )
}
